import React from 'react';

import { Loader } from '@/components/shared/Loader';
import { useAuth } from '@/providers/AuthProvider';
import { useTeam } from '@/providers/TeamProvider';

import { AccountDisplayProps } from '../AccountPanel';
import { UserInvite } from './UserInvite';

export const SettingAddTeamMember: React.FC<AccountDisplayProps> = () => {
	const { team } = useTeam();
	const { user } = useAuth();

	if (!team || !team.members) {
		return <Loader />;
	}

	const self = team.members.find((member) => member?.user.id === user.id);

	return <UserInvite canAssignAdmin={!!self?.roles.includes('teamAdmin')} />;
};
